import { AdminsApi, AuthorizedAppsApi, Configuration, RolesApi } from '@coretava/api/security-service';
import { apiClient } from './client';

const config = new Configuration({
  basePath: apiClient.defaults.baseURL || '',
});

export const adminsApi = new AdminsApi(config, undefined, apiClient);
export const authorizedAppsApi = new AuthorizedAppsApi(config, undefined, apiClient);
export const rolesApi = new RolesApi(config, undefined, apiClient);
